module.exports = __webpack_public_path__ + "img/744.ab1c6994.jpg";